module.exports = __webpack_public_path__ + "static/full-demo-ec90627c3da3648d4e9af1b8ad3dba6b.jpg";